var OCS = OCS || {};
OCS.Viewer = OCS.Viewer || {};
OCS.Viewer.Live = OCS.Viewer.Live || {};
OCS.Viewer.Classes = OCS.Viewer.Classes || {};
OCS.Viewer.Functions = OCS.Viewer.Functions || {};
OCS.Viewer.Palettes = OCS.Viewer.Palettes || {};

OCS.Viewer.Classes.PaletteManager = new Class({
    Extends: OCS.Viewer.Classes.SingletonManager,
    class_name: "PaletteManager",
    manager_name: 'PaletteManager',
    palette_prefix: "palette_",
    get_palette: function (name) {
        if (name) {
            if (OCS.Viewer.Palettes[this.palette_prefix + name]) {
                return OCS.Viewer.Palettes[this.palette_prefix + name];
            }
            if (OCS.Viewer.ColorCurves[name]) {
                return this.create_palette(name, OCS.Viewer.ColorCurves[name]);
            }
        }
        return false;
    },
    get_palette_name_from_ops: function (ops) {
        var name = "";
        if (!ops) {
            ops = {};
        }
        if (ops.parm) {
            name += ops.parm;
        } else {
            name += "default";
        }
        if (ops.use_auto) {
            name += "-auto";
            var util = OCS.Viewer.Functions.get_utilities();
            if (util.isNumber(ops.max_val)) {
                name += "|" + ops.max_val;
            }
            if (util.isNumber(ops.min_val)) {
                name += "|" + ops.min_val;
            }
        } else {
            name += "-standard";
        }

        return name;
    },
    create_palette: function (name, color_gradient, ops) {
        var palette_ops = {color_gradient: color_gradient, gradient_name: name};
        if (ops) {
            var util = OCS.Viewer.Functions.get_utilities();
            if (util.isNumber(ops.min_val)) {
                palette_ops.min_val = parseFloat(ops.min_val);
            }
            if (util.isNumber(ops.max_val)) {
                palette_ops.max_val = parseFloat(ops.max_val);
            }
        }
        return this.add_palette(name, new OCS.Viewer.Classes.Palette(palette_ops));
    },
    add_palette: function (name, palette) {
        OCS.Viewer.Palettes[this.palette_prefix + name] = palette;
        return palette;
    },
    delete_palette: function (name) {
        delete OCS.Viewer.Palettes[this.palette_prefix + name];
    },
    destroy: function () {
        var names = Object.keys(OCS.Viewer.Palettes);
        names.each(function (name) {
            delete OCS.Viewer.Palettes[name];
        }.bind(this));
        this.destroy_manager();
    }

});
OCS.Viewer.Functions.get_palette_manager = function () {
    if (!OCS.Viewer.Live.PaletteManager) {
        new OCS.Viewer.Classes.PaletteManager();
    }
    return OCS.Viewer.Live.PaletteManager;
};

